import type { AemBookingDay, ITimeSlot } from 'Types/aemui/schedule-a-tour/scheduleATour';
import type { IBookingsService, IStaffAvailability } from 'Types/bookings/bookings';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);

const PacificStandardTime = 'Pacific Standard Time';
const MountainStandardTime = 'Mountain Standard Time';
const CentralStandardTime = 'Central Standard Time';
const EasternStandardTime = 'Eastern Standard Time';
const ArizonaStandardTime = 'US Mountain Standard Time';

export function getAvailableTimeSlots(
	service: IBookingsService,
	availability: IStaffAvailability,
	timeZone: string,
	bookingsBusiness: string
): AemBookingDay[] {
	const staffId = availability.staffId;
	const serviceId = service.id;
	const openTimes = availability.availabilityItems.filter((x) => x.status === 'available');
	const maximumAdvance = dayjs.duration(service.schedulingPolicy.maximumAdvance).asDays();
	const availableResponse = getBaseArray(maximumAdvance);
	const timeSlotInterval = dayjs.duration(service.schedulingPolicy.timeSlotInterval).asMinutes();
	const leadTime = dayjs.duration(service.schedulingPolicy.minimumLeadTime).asMinutes();

	openTimes.forEach((element) => {
		const now = dayjs.utc();
		const start = dayjs.utc(element.startDateTime.dateTime);
		const end = dayjs.utc(element.endDateTime.dateTime);

		const numberOfSlots = end.diff(start, 'minutes') / timeSlotInterval;

		for (let i = 0; i < numberOfSlots; i++) {
			const startTime = start.add(i * timeSlotInterval, 'minute');
			if (now.diff(startTime, 'minute') >= leadTime * -1) {
				continue;
			}

			const slot = {
				startTime: startTime.tz(timeZone).toISOString(),
				endTime: start
					.add((i + 1) * timeSlotInterval, 'minute')
					.tz(timeZone)
					.toISOString(),
				staffId: staffId,
				serviceId: serviceId,
				timeZone: timeZone,
				bookingsBusiness: bookingsBusiness
			} as ITimeSlot;

			const dayObject = availableResponse.find(
				(x) => x.dayObject.format('DD/MM/YYYY') === dayjs(start).tz(timeZone).format('DD/MM/YYYY')
			);

			dayObject?.timeSlots.push(slot);
		}
	});

	return availableResponse;
}

function getBaseArray(days: number): AemBookingDay[] {
	const array = [] as AemBookingDay[];
	const daysToRoundToEvenWeeks = 7 - (days % 7);
	const accountForZeroIndex = 1;
	const end = days + daysToRoundToEvenWeeks - accountForZeroIndex;

	for (let i = 0; i <= end; i++) {
		const day = {} as AemBookingDay;
		day.dayObject = dayjs().add(i, 'day');
		day.timeSlots = [] as ITimeSlot[];
		array.push(day);
	}

	return array;
}

//I don't love this but it's a stop gap until we can get a 3rd party library approved for this translation
//I looked through the club store and at least it seems we've standardized thoes to these 5
export function getWindowsTimeZone(ianaTimezone: string): string {
	switch (ianaTimezone) {
		case 'America/Los_Angeles':
			return PacificStandardTime;
		case 'America/Chicago':
			return CentralStandardTime;
		case 'America/Denver':
			return MountainStandardTime;
		case 'America/New_York':
			return EasternStandardTime;
		case 'America/Phoenix':
			return ArizonaStandardTime;
		default:
			return 'UTC';
	}
}
